import { MakerData, PoinInfo, RecoveryHistoryStatistics} from "../../types/type";
import { PointHistoryInfo} from "../../types/type";
import axios, { AxiosResponse } from "axios";
import i18next from "i18next";

export const authSignup = async (userName:string,email:string,gender:string,age:string,country_id:number,zipCode:string,address:string,latitude:number,longitude:number,password:string,password_confirmation:string,setAlertsMessage:React.Dispatch<React.SetStateAction<string>>,setSeverity:React.Dispatch<React.SetStateAction<"error" | "success">>,setOpenSnackbar:React.Dispatch<React.SetStateAction<boolean>>,setIsWaitingResponse:React.Dispatch<React.SetStateAction<boolean>>): Promise<string | null> => {    
    try {
        setIsWaitingResponse(true);
        const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL!}/api/auth/signup`, {
            user: {
                email: email,
                gender:gender,
                age:age,
                country_id:country_id,
                name: userName,
                password: password,
                password_confirmation: password_confirmation
            },
            my_area: {
                zip_code: zipCode,
                address:address,
                latitude: latitude,
                longitude: longitude
            },
        });
        setAlertsMessage(i18next.t("api.registerSuccess"));
        setSeverity("success");
        setOpenSnackbar(true);
        return response.data.token;
    } catch (error:any) {
        if(error.response.data.error.type === "validation_error"){
            setAlertsMessage(error.response.data.error.message);
            setSeverity("error");
            setOpenSnackbar(true);
            return null;
        }else{
            setAlertsMessage(i18next.t("api.registerFail"));
            setSeverity("error");
            setOpenSnackbar(true);
            return null;    
        }
    } finally {
        setIsWaitingResponse(false);
    }};

export const authSignin = async (email:string,password:string,setAlertsMessage:React.Dispatch<React.SetStateAction<string>>,setSeverity:React.Dispatch<React.SetStateAction<"error" | "success">>,setOpenSnackbar:React.Dispatch<React.SetStateAction<boolean>>): Promise<string | null> => {    
    try {
        const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL!}/api/auth/signin`, {
            user_session: {
                email: email,
                password: password
            },
        });
        setAlertsMessage(i18next.t("api.loginSuccess"));
        setSeverity("success");
        setOpenSnackbar(true);
        return response.data.token;
    } catch (error:any) {
        if(error.response.data.error.type === "validation_error"){
            setAlertsMessage(error.response.data.error.message);
            setSeverity("error");
            setOpenSnackbar(true);
            return null;
        }else{
            setAlertsMessage(i18next.t("api.loginFail"));
            setSeverity("error");
            setOpenSnackbar(true);
            return null;    
        }
    }
};

export const authSignout = async (recotech_mapapps_token:string,setAlertsMessage:React.Dispatch<React.SetStateAction<string>>,setSeverity:React.Dispatch<React.SetStateAction<"error" | "success">>,setOpenSnackbar:React.Dispatch<React.SetStateAction<boolean>>): Promise<boolean> => {
    try {
        const Authorization = `Bearer ${recotech_mapapps_token}`;
        await axios.delete(`${process.env.REACT_APP_BACKEND_URL!}/api/auth/signout`, {
            headers: {
                Authorization,
            }
        });
        setAlertsMessage(i18next.t("api.logoutSuccess"));
        setSeverity("success");
        setOpenSnackbar(true);
        return true;
    } catch (error:any) {
        if(error.response.data.error.type === "invalid_token"){
            setAlertsMessage(i18next.t("api.sessionExpired"));
            setSeverity("error");
            setOpenSnackbar(true);
            return false;    
        }else if(error.response.data.error.type === "validation_error"){
            setAlertsMessage(error.response.data.error.message);
            setSeverity("error");
            setOpenSnackbar(true);
            return false;    
        }else{
            setAlertsMessage(i18next.t("api.logoutFail"));
            setSeverity("error");
            setOpenSnackbar(true);
            return false;    
        }
    }
};

export const authWithdraw = async (recotech_mapapps_token:string,setAlertsMessage:React.Dispatch<React.SetStateAction<string>>,setSeverity:React.Dispatch<React.SetStateAction<"error" | "success">>,setOpenSnackbar:React.Dispatch<React.SetStateAction<boolean>>): Promise<boolean> => {
    try {
        const Authorization = `Bearer ${recotech_mapapps_token}`;
        await axios.delete(`${process.env.REACT_APP_BACKEND_URL!}/api/auth/withdraw`, {
            headers: {
                Authorization,
            }
        });
        setAlertsMessage(i18next.t("api.deleteAccountSuccess"));
        setSeverity("success");
        setOpenSnackbar(true);
        return true;
    } catch (error: any) {
        if(error.response.data.error.type === "invalid_token"){
            setAlertsMessage(i18next.t("api.sessionExpired"));
            setSeverity("error");
            setOpenSnackbar(true);
            return false;    
        }else if(error.response.data.error.type === "validation_error"){
            setAlertsMessage(error.response.data.error.message);
            setSeverity("error");
            setOpenSnackbar(true);
            return false;    
        }else{
            setAlertsMessage(i18next.t("api.deleteAccountFail"));
            setSeverity("error");
            setOpenSnackbar(true);
            return false;    
        }
    }
};

export const getMyPlacesApi = async (recotech_mapapps_token:string,removeCookie:(name: "recotech_mapapps_token") => void):Promise<number[]>=>{
    try {
        const Authorization = `Bearer ${recotech_mapapps_token}`;
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL!}/api/my_recovery_places`, {
            headers: {
                Authorization,
            }
        });
            return response.data.recovery_place_ids
    } catch (error: any) {
        if(error.response.data.error.type === "invalid_token"){
            removeCookie("recotech_mapapps_token")
            return [];
        }else{
            return [];
        }
    }
};

export const getBookmarksApi = async (recotech_mapapps_token:string,removeCookie:(name: "recotech_mapapps_token") => void):Promise<number[]>=>{
    try {
        const Authorization = `Bearer ${recotech_mapapps_token}`;
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL!}/api/bookmarks`, {
            headers: {
                Authorization,
            }
        });
            return response.data.recovery_place_ids
    } catch (error: any) {
        if(error.response.data.error.type === "invalid_token"){
            removeCookie("recotech_mapapps_token")
            return [];
        }else{
            return [];
        }
    }
};

export const setBookmarkApi = async (recotech_mapapps_token:string,recovery_place_id:number,setAlertsMessage:React.Dispatch<React.SetStateAction<string>>,setSeverity:React.Dispatch<React.SetStateAction<"error" | "success">>,setOpenSnackbar:React.Dispatch<React.SetStateAction<boolean>>,setIsWaitingResponse:React.Dispatch<React.SetStateAction<boolean>>):Promise<number[]>=>{
    try {
        setIsWaitingResponse(true);
        const Authorization = `Bearer ${recotech_mapapps_token}`;
        const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL!}/api/bookmarks`, 
        {            
            bookmark: {
                recovery_place_id: recovery_place_id,
        }},
        {
            headers: {
                Authorization,
            }
        });
        setAlertsMessage(i18next.t("api.bookmarkAddSuccess"));
        setSeverity("success");
        setOpenSnackbar(true);
        return response.data.recovery_place_ids
    } catch (error: any) {
        if(error.response.data.error.type === "invalid_token"){
            setAlertsMessage(i18next.t("api.sessionExpired"));
            setSeverity("error");
            setOpenSnackbar(true);
            return [];
        }else if(error.response.data.error.type === "validation_error"){
            setAlertsMessage(error.response.data.error.message);
            setSeverity("error");
            setOpenSnackbar(true);
            return [];
        }else{
            setAlertsMessage(i18next.t("api.bookmarkAddFail"));
            setSeverity("error");
            setOpenSnackbar(true);
            return [];
        }
    } finally {
        setIsWaitingResponse(false);
    }
};

export const deleteBookmarkApi = async (recotech_mapapps_token:string,recovery_place_id:number,setAlertsMessage:React.Dispatch<React.SetStateAction<string>>,setSeverity:React.Dispatch<React.SetStateAction<"error" | "success">>,setOpenSnackbar:React.Dispatch<React.SetStateAction<boolean>>,setIsWaitingResponse:React.Dispatch<React.SetStateAction<boolean>>):Promise<number[] | null>=>{
    try {
        setIsWaitingResponse(true);
        const Authorization = `Bearer ${recotech_mapapps_token}`;
        const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL!}/api/bookmarks/delete`, 
        {            
            bookmark: {
                recovery_place_id: recovery_place_id,
        }},
        {
            headers: {
                Authorization,
            }
        });
        setAlertsMessage(i18next.t("api.bookmarkDeleteSuccess"));
        setSeverity("success");
        setOpenSnackbar(true);
        return response.data.recovery_place_ids
    } catch (error: any) {
        if(error.response.data.error.type === "invalid_token"){
            setAlertsMessage(i18next.t("api.sessionExpired"));
            setSeverity("error");
            setOpenSnackbar(true);
            return null;
        }else if(error.response.data.error.type === "validation_error"){
            setAlertsMessage(error.response.data.error.message);
            setSeverity("error");
            setOpenSnackbar(true);
            return null;
        }else{
            setAlertsMessage(i18next.t("api.bookmarkDeleteFail"));
            setSeverity("error");
            setOpenSnackbar(true);
            return null;
        }
    } finally {
        setIsWaitingResponse(false);
    }
};

export const getMyAreaApi = async (recotech_mapapps_token:string,removeCookie:(name: "recotech_mapapps_token") => void):Promise<{zipCode:string | null,address:string | null , latitude:number | null ,longitude:number | null
}>=> {    
    try {
        const Authorization = `Bearer ${recotech_mapapps_token}`;
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL!}/api/my_area`, {
            headers: {
                Authorization,
            }
        });
            return {zipCode:response.data.my_area.zip_code,address:response.data.my_area.address,latitude:response.data.my_area.latitude,longitude:response.data.my_area.longitude};

    } catch (error: any) {
        if(error.response.data.error.type === "invalid_token"){
            removeCookie("recotech_mapapps_token")
            return {zipCode:null,address:null,latitude:null,longitude:null};
        }else{
            return {zipCode:null,address:null,latitude:null,longitude:null};
        }
    }
};

export const setMyAreaApi = async (recotech_mapapps_token:string,zipCode:string,address:string,latitude:number,longitude:number,setAlertsMessage:React.Dispatch<React.SetStateAction<string>>,setSeverity:React.Dispatch<React.SetStateAction<"error" | "success">>,setOpenSnackbar:React.Dispatch<React.SetStateAction<boolean>>,setIsWaitingResponse:React.Dispatch<React.SetStateAction<boolean>>):Promise<{zipCode:string | null,address:string | null}>=> {    
    try {
        setIsWaitingResponse(true);
        const Authorization = `Bearer ${recotech_mapapps_token}`;
        const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL!}/api/my_area`, 
        {            
            my_area: {
                zip_code: zipCode,
                address:address,
                latitude: latitude,
                longitude: longitude
            },
        },
        {
            headers: {
                Authorization,
            }
        });
        setAlertsMessage(i18next.t("api.myAreaSuccess"));
        setSeverity("success");
        setOpenSnackbar(true);
        return {zipCode:response.data.my_area.zip_code,address:response.data.my_area.address}; 

    } catch (error: any) {
        if(error.response.data.error.type === "invalid_token"){
            setAlertsMessage(i18next.t("api.sessionExpired"));
            setSeverity("error");
            setOpenSnackbar(true);
            return {zipCode:null,address:null};
        }else if(error.response.data.error.type === "validation_error"){
            setAlertsMessage(error.response.data.error.message);
            setSeverity("error");
            setOpenSnackbar(true);
            return {zipCode:null,address:null};
        }else{
            setAlertsMessage(i18next.t("api.myAreaFail"));
            setSeverity("error");
            setOpenSnackbar(true);
            return {zipCode:null,address:null};
        }
    } finally {
        setIsWaitingResponse(false);
    }
};

export const getCategoriesApi = async (setAlertsMessage:React.Dispatch<React.SetStateAction<string>>,setSeverity:React.Dispatch<React.SetStateAction<"error" | "success">>,setOpenSnackbar:React.Dispatch<React.SetStateAction<boolean>>,country_id?: number):Promise<any[]>=>{    
    try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL!}/api/categories`, {
            params: {
                country_id: country_id
            }
        });
            return response.data.categories
    } catch (error: any) {
        if(error.response.data.error.type === "validation_error"){
            setAlertsMessage(error.response.data.error.message);
            setSeverity("error");
            setOpenSnackbar(true);
            return [];
        }else{
            setAlertsMessage(i18next.t("api.fetchFail"));
            setSeverity("error");
            setOpenSnackbar(true);
            return [];
        }
    }
};

export const getPlacesApi = async (max:number,latitude:number,longitude:number,distance:number,setAlertsMessage:React.Dispatch<React.SetStateAction<string>>,setSeverity:React.Dispatch<React.SetStateAction<"error" | "success">>,setOpenSnackbar:React.Dispatch<React.SetStateAction<boolean>>,zipCode?:string):Promise<MakerData[]>=>{
    try {

        let response: AxiosResponse<any, any> | undefined;

        if(typeof zipCode === "undefined"){
            response = await axios.get(`${process.env.REACT_APP_BACKEND_URL!}/api/places`, {
                params:{
                    max: max,
                    latitude: latitude,
                    longitude: longitude,
                    distance: distance,
                },
            });    
        }else{
            response = await axios.get(`${process.env.REACT_APP_BACKEND_URL!}/api/places`, {
                params:{
                    max: max,
                    latitude: latitude,
                    longitude: longitude,
                    distance: distance,
                    zip_code: zipCode,
                },
            });    
        }

        const markDataList:MakerData[] = response!.data.recovery_places.map((place:any)=>{
            return {
                id: Number(place.id),
                latitude: Number(place.latitude),
                longitude: Number(place.longitude),
                name: place.name,
                imageUrl: place.image_url??'noimage.jpeg',
                iconUrl: './assets/pin_nomal.png',
                categoryNames: place.category_names,
                zipCode: place.zip_code,
                address: place.address,
                phoneNumber: place.phone_number,
                whatsappNumber: place.whatsapp_number,
                description: place.description,
                regularHolidays: place.regular_holidays,
                businessHours: place.business_hours,
                createdAt: new Date(place.created_at),
                updatedAt: new Date(place.updated_at),
            }
        })
        return markDataList;
    } catch (error: any) {
        if(error.response.data.error.type === "validation_error"){
            setAlertsMessage(error.response.data.error.message);
            setSeverity("error");
            setOpenSnackbar(true);
            return [];
        }else{
            setAlertsMessage(i18next.t("api.fetchFail"));
            setSeverity("error");
            setOpenSnackbar(true);
            return [];
        }
    }
}

export const getPlaceBookmarksApi = async (recotech_mapapps_token:string,removeCookie:(name: "recotech_mapapps_token") => void):Promise<MakerData[]>=>{
    try {
        const Authorization = `Bearer ${recotech_mapapps_token}`;
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL!}/api/places/bookmarks`, {
            headers: {
                Authorization,
            }
        });
        const markDataList:MakerData[] = response!.data.recovery_places.map((place:any)=>{
            return {
                id: Number(place.id),
                latitude: Number(place.latitude),
                longitude: Number(place.longitude),
                name: place.name,
                imageUrl: place.image_url??'noimage.jpeg',
                iconUrl: './assets/pin_nomal.png',
                categoryNames: place.category_names,
                zipCode: place.zip_code,
                address: place.address,
                phoneNumber: place.phone_number,
                whatsappNumber: place.whatsapp_number,
                description: place.description,
                regularHolidays: place.regular_holidays,
                businessHours: place.business_hours,
                createdAt: new Date(place.created_at),
                updatedAt: new Date(place.updated_at),
            }
        })
        return markDataList;
    } catch (error: any) {
        if(error.response.data.error.type === "invalid_token"){
            removeCookie("recotech_mapapps_token")
            return [];
        }else{
            return [];
        }
    }
};

export const getPlaceStatisticsApi = async (id:number,setAlertsMessage:React.Dispatch<React.SetStateAction<string>>,setSeverity:React.Dispatch<React.SetStateAction<"error" | "success">>,setOpenSnackbar:React.Dispatch<React.SetStateAction<boolean>>):Promise<RecoveryHistoryStatistics | null>=>{
    try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL!}/api/places/statistics/${id}`, {
        });
        return response.data.statistics
    } catch (error: any) {
        if(error.response.data.error.type === "validation_error"){
            setAlertsMessage(error.response.data.error.message);
            setSeverity("error");
            setOpenSnackbar(true);
            return null;
        }else{
            setAlertsMessage(i18next.t("api.fetchFail"));
            setSeverity("error");
            setOpenSnackbar(true);
            return null;
        }
    }
};

export const getPlacePointsApi = async (id:number,setAlertsMessage:React.Dispatch<React.SetStateAction<string>>,setSeverity:React.Dispatch<React.SetStateAction<"error" | "success">>,setOpenSnackbar:React.Dispatch<React.SetStateAction<boolean>>,setIsWaitingResponse:React.Dispatch<React.SetStateAction<boolean>>):Promise<PoinInfo | null>=>{
    try {
        setIsWaitingResponse(true);
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL!}/api/places/points/${id}`, {
        });
        return response.data.user
    } catch (error: any) {
        if(error.response.data.error.type === "validation_error"){
            setAlertsMessage(error.response.data.error.message);
            setSeverity("error");
            setOpenSnackbar(true);
            return null;
        }else{
            setAlertsMessage(i18next.t("api.fetchFail"));
            setSeverity("error");
            setOpenSnackbar(true);
            return null;
        }
    } finally {
        setIsWaitingResponse(false);
    }
};

export const setPlaceApi = async (
    recotech_mapapps_token:string,
    formData: FormData,
    setAlertsMessage:React.Dispatch<React.SetStateAction<string>>,
    setSeverity:React.Dispatch<React.SetStateAction<"error" | "success">>,
    setOpenSnackbar:React.Dispatch<React.SetStateAction<boolean>>,
    setIsWaitingResponse:React.Dispatch<React.SetStateAction<boolean>>
    ):Promise<boolean>=> {    
    try {
        setIsWaitingResponse(true);
        const Authorization = `Bearer ${recotech_mapapps_token}`;
        await axios.post(`${process.env.REACT_APP_BACKEND_URL!}/api/places`, 
        formData,
        {
            headers: {
                Authorization,
                'Content-Type': 'multipart/form-data',
            }
        });
        setAlertsMessage(i18next.t("api.requestSuccess"));
        setSeverity("success");
        setOpenSnackbar(true);
        return true; 

    } catch (error: any) {
        if(error.response.data.error.type === "invalid_token"){
            setAlertsMessage(i18next.t("api.sessionExpired"));
            setSeverity("error");
            setOpenSnackbar(true);
            return false;    
        }else if(error.response.data.error.type === "validation_error"){
            setAlertsMessage(error.response.data.error.message);
            setSeverity("error");
            setOpenSnackbar(true);
            return false;    
        }else{
            setAlertsMessage(i18next.t("api.requestFail"));
            setSeverity("error");
            setOpenSnackbar(true);
            return false;    
        }
    } finally {
        setIsWaitingResponse(false);
    }
};
export const getRecoveryHistoryApi = async (recotech_mapapps_token:string,removeCookie:(name: "recotech_mapapps_token") => void):Promise<RecoveryHistoryStatistics | null>=>{
    try {
        const Authorization = `Bearer ${recotech_mapapps_token}`;
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL!}/api/recovery_histories`, {
            headers: {
                Authorization,
            }
        });
        return response.data.recovery_history

    } catch (error: any) {
        if(error.response.data.error.type === "invalid_token"){
            removeCookie("recotech_mapapps_token")
            return null;
        }else{
            return null;
        }
    }
};

export const setRecoveryHistoryApi = async (
    recotech_mapapps_token:string,
    formData: FormData,
    setAlertsMessage:React.Dispatch<React.SetStateAction<string>>,
    setSeverity:React.Dispatch<React.SetStateAction<"error" | "success">>,
    setOpenSnackbar:React.Dispatch<React.SetStateAction<boolean>>,
    setIsWaitingResponse:React.Dispatch<React.SetStateAction<boolean>>
    ):Promise<boolean>=> {    
    try {
        setIsWaitingResponse(true);
        const Authorization = `Bearer ${recotech_mapapps_token}`;
        await axios.post(`${process.env.REACT_APP_BACKEND_URL!}/api/recovery_histories`, 
        formData,
        {
            headers: {
                Authorization,
                'Content-Type': 'multipart/form-data',
            }
        });
        setAlertsMessage(i18next.t("api.resourceSuccess"));
        setSeverity("success");
        setOpenSnackbar(true);
        return true; 

    } catch (error: any) {
        if(error.response.data.error.type === "invalid_token"){
            setAlertsMessage(i18next.t("api.sessionExpired"));
            setSeverity("error");
            setOpenSnackbar(true);
            return false;    
        }else if(error.response.data.error.type === "validation_error"){
            setAlertsMessage(error.response.data.error.message);
            setSeverity("error");
            setOpenSnackbar(true);
            return false;    
        }else{
            setAlertsMessage(i18next.t("api.resourceFail"));
            setSeverity("error");
            setOpenSnackbar(true);
            return false;    
        }
    } finally {
        setIsWaitingResponse(false);
    }
};

export const getPointHistroyApi = async (page:number,recotech_mapapps_token:string,removeCookie:(name: "recotech_mapapps_token") => void):Promise<PointHistoryInfo | null>=>{
    try {
        const Authorization = `Bearer ${recotech_mapapps_token}`;
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL!}/api/points/history?page=${page}`, {
            headers: {
                Authorization,
            }
        });
        return response.data;
    } catch (error: any) {
        if(error.response.data.error.type === "invalid_token"){
            removeCookie("recotech_mapapps_token")
            return null;
        }else{
            return null;
        }
    }
};

export const getPointApi = async (recotech_mapapps_token:string,removeCookie:(name: "recotech_mapapps_token") => void):Promise<PoinInfo | null>=>{
    try {
        const Authorization = `Bearer ${recotech_mapapps_token}`;
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL!}/api/points`, {
            headers: {
                Authorization,
            }
        });
        return response.data.user;
    } catch (error: any) {
        if(error.response.data.error.type === "invalid_token"){
            removeCookie("recotech_mapapps_token")
            return null;
        }else{
            return null;
        }
    }
};